﻿$.fn.dxCtrlBcArbo = function custom_dxCtrlBcArbo(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlbcarbo dx-ctrl");
        this.createInstance(new cdxCtrlBcArbo(this, option));
    }
    return this;
}

window.cdxCtrlBcArbo = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    var $TdLink = null
    var $TdNewDossier = null
    var $TdNewArticle = null
    function mConstruit() {
        container.empty();

        var $Table = $("<table style='width:100%;'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        $TdLink = $("<td style='width:100%;'/>").appendTo($Table)
        $TdModifDossier = $("<td style='width:0px;'/>").appendTo($Table)
        $TdNewDossier = $("<td style='width:0px;'/>").appendTo($Table)
        $TdNewArticle = $("<td style='width:0px;'/>").appendTo($Table)


        var entre = "<span style='color:" + theme.backgroundcolorAccent + ";font-weight:bold;'> &gt; </span>"

        if (option.elementBc == null) {
            if (option.txtSearch == null || option.txtSearch.length == 0) {
                //on est sur l'accueil
                mAddAccueil(false)
                if (!option.readOnly && (option.appli == null || typeof option.appli.bcAppli == 'undefined' || option.appli.bcAppli.id_bc_appli == "0")) {
                    mAddLinkNewDossier(null)
                }
            } else {
                //on est sur une recherche
                mAddAccueil(true)
                $(entre).appendTo($TdLink)
                mAddRecherche(false)
            }
        } else {
            var obj = option.bddCtrl.getObjet(option.elementBc)
            var lst = obj.objetMetier.mGetLstParent()

            mAddAccueil(true)

            if (option.txtSearch != null && option.txtSearch.length != 0) {
                $(entre).appendTo($TdLink)
                mAddRecherche(true)
            }

            lst.forEach(function (data, idx) {
                $(entre).appendTo($TdLink)
                if (idx == lst.length - 1) {
                    $("<span style='" + ((option.bddCtrl.getObjet(data).mGetTable().nom == 'bc_article') ? "font-style:italic;" : "") + "'>" + data.objet.replace(/%%nom_appli%%/g, gestCognoss.mGetAppliCourante().nom) + "</span>").appendTo($TdLink)
                } else {
                    var $A = $("<a href='javascript:void(0)'>" + data.objet.replace(/%%nom_appli%%/g, gestCognoss.mGetAppliCourante().nom) + "</a>").appendTo($TdLink)
                    $A.on("click", function () { option.onSelect(data) })
                }
            })

            if (!option.readOnly && (option.appli == null || typeof option.appli.bcAppli == 'undefined' || option.appli.bcAppli.id_bc_appli == "0") &&
                option.bddCtrl.getObjet(option.elementBc).mGetTable().nom == "bc_dossier") {
                mAddLinkNewDossier(option.elementBc)
            }
        }
    }

    function mAddAccueil(withClick) {
        if (withClick) {
            var $A = $("<a href='javascript:void(0)'>Accueil</a>").appendTo($TdLink)
            $A.on("click", function () { option.onSelect(null) })
        } else {
            $("<span>Accueil</span>").appendTo($TdLink)
        }
    }
    function mAddRecherche(withClick) {
        var txt = option.txtSearch
        if (txt.length > 20) txt = option.txtSearch.substring(0, 9) + "..." + option.txtSearch.substring(option.txtSearch.length - 9)
        if (withClick) {
            var $A = $("<a href='javascript:void(0)'>Recherche <i style='font-size:80%;'>'" + txt + "'</i></a>").appendTo($TdLink)
            $A.on("click", function () { option.onSelect(option.txtSearch) })
        } else {
            $("<span>Recherche <i style='font-size:80%;'>'" + txt + "'</i></span>").appendTo($TdLink)
        }
    }

    function mAddLinkNewDossier(dossier) {
        if (dossier != null) {
            $("<a href='javascript:void(0)' style='font-family:barlow condensed;padding-right:5px;'>modif&nbsp;dossier</a>").appendTo($TdModifDossier).on("click", function (e) {
                option.bddCtrl.getObjet(dossier).mShowPopup()
            })
        }
        $("<div/>").appendTo($TdNewDossier).dxCtrlButton({
            icon: "fas fa-folder-closed",
            icon2: "fas fa-certificate",
            colorIcone2: theme.colorBtIcon2,
            opacityIcone2: "0.9",
            txtTooltip: "Créer un nouveau dossier<br/>" + ((option.elementBc) ? "dans le dossier<br/><b>" + option.elementBc.objet + "</b>" : "à la racine"),
            onClick: function (e) {
                var newData = option.bddCtrl.getObjet("bc_dossier").mGetNewData()
                newData.id_bc_dossier_parent = ((dossier) ? dossier.id_bc_dossier : null)
                option.bddCtrl.getObjet(newData).mShowPopup()
                //option.bddCtrl.getObjet(newData).objetMetier.mShowPopup({
                //    onHidden: function (e) {
                //        if (newData.id_bc_dossier != null) option.onCreateNew(newData)
                //    }
                //})
            }
        })
        $("<div/>").appendTo($TdNewArticle).dxCtrlButton({
            icon: "fas fa-graduation-cap",
            icon2: "fas fa-certificate",
            colorIcone2: theme.colorBtIcon2,
            opacityIcone2: "0.9",
            txtTooltip: "Créer un nouvel article<br/>" + ((option.elementBc) ? "dans le dossier<br/><b>" + option.elementBc.objet + "</b>" : "à la racine"),
            onClick: function (e) {
                var newData = option.bddCtrl.getObjet("bc_article").mGetNewData()
                newData.id_bc_dossier_parent = ((dossier) ? dossier.id_bc_dossier : null)
                newData.objet = "Nouvel article"
                newData.body_txt = ""
                option.bddCtrl.getObjet(newData).mShowPopup()
            }
        })
    }

    this.element = function () { return container; }

    mConstruit();
}